/*
 * Steel Pony Farm — make any product name fit its card, forever, with no upkeep.
 *
 * THE PROBLEM THIS REPLACES
 * Card titles sit in a fixed three-line box (see snippets/product-card.liquid). Three
 * lines covers the catalogue as it stands, but "Frozen Meal, Mushroom Swiss Cheeseburger
 * Casserole" needs four, and the next long name somebody adds will need four too. The
 * options were to hand-shorten product names — which rots the moment anyone forgets — or
 * to make every card taller for the sake of a handful of products. Neither is maintenance
 * free, which is the bar Mike set.
 *
 * WHY NOT DO IT IN LIQUID
 * Bucketing by title length looked tempting and does not work. Measured on the live
 * catalogue: "Apple Cider Vinegar, Raw Unfiltered, Organic" (44 chars) needs 15px, while
 * "Frozen Meal, Creamy Butternut Bison Spaghetti" (45 chars) fits at 16px. Rendered width
 * is driven by the LONGEST WORD as much as the total, so any character-count rule is
 * wrong for some names and silently gets wronger as the catalogue changes.
 *
 * WHAT THIS DOES
 * Steps the font size down — 17, 16, 15, 14, 13, 12 — until the name fits three lines,
 * measured against the real rendered text. Only 7 of 250 current products need anything
 * below 17px, so for almost every card this is one measurement and no change.
 *
 * WHY IT CANNOT CAUSE LAYOUT SHIFT
 * The title box has a FIXED height. Shrinking text inside a fixed box changes nothing
 * outside it, so this runs after paint without moving a single pixel of the page. That is
 * the whole reason it is safe to do in JS at all — it would not have been before the box
 * was pinned.
 *
 * FAILURE MODE
 * If this script never runs (old browser, blocked asset), the CSS three-line clamp still
 * applies and you get today's behaviour: a rare long name truncated. Strictly no worse.
 *
 * PERFORMANCE
 * Reads are batched, then writes, then only the still-overflowing titles are re-measured.
 * With ~150 cards that is three or four batched layouts, not 150 interleaved ones.
 */
(function () {
  'use strict';

  var SIZES = [17, 16, 15, 14, 13, 12];
  var SEL = '.product-card__content [role="heading"]';
  var MARK = 'spfFit'; // dataset flag: this title has been fitted

  function overflowing(el) {
    // 1px of slack: sub-pixel line metrics can make an exactly-fitting box read as 1 over.
    return el.scrollHeight > el.clientHeight + 1;
  }

  function fit(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var all = scope.querySelectorAll(SEL);
    var pending = [];
    var i;

    for (i = 0; i < all.length; i++) {
      if (all[i].dataset && all[i].dataset[MARK]) continue;
      pending.push(all[i]);
    }
    if (!pending.length) return;

    // Round 0: one batched read. Most titles fit at the base size and drop out here.
    var live = [];
    for (i = 0; i < pending.length; i++) {
      if (pending[i].dataset) pending[i].dataset[MARK] = '1';
      if (overflowing(pending[i])) live.push(pending[i]);
    }

    // Rounds 1..n: shrink everything still overflowing, then re-read as one batch.
    for (var step = 1; step < SIZES.length && live.length; step++) {
      for (i = 0; i < live.length; i++) live[i].style.fontSize = SIZES[step] + 'px';
      var still = [];
      for (i = 0; i < live.length; i++) if (overflowing(live[i])) still.push(live[i]);
      live = still;
    }
    // Anything still over at the smallest size keeps the CSS clamp. A name that long is a
    // catalogue problem, not a layout one, and it degrades to today's behaviour.
  }

  // Exposed so the lazy row loader can fit cards the moment it inserts them, instead of
  // this file having to watch the DOM. See assets/spf-lazy-sections.js.
  window.SPFFitTitles = fit;

  function start() { fit(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
